import { xeroOnboardingRoutine, xeroAuthRoutine, xeroOriginRoutine, xeroIsXeroLoginRoutine } from '@/store/modules/xero/routines'

export default {
  [xeroOnboardingRoutine.TRIGGER](context, payload) {
    context.commit(xeroOnboardingRoutine.TRIGGER, payload)
  },
  [xeroAuthRoutine.TRIGGER](context, payload) {
    context.commit(xeroAuthRoutine.TRIGGER, payload)
  },
  [xeroOriginRoutine.TRIGGER](context, payload) {
    context.commit(xeroOriginRoutine.TRIGGER, payload)
  },
  [xeroIsXeroLoginRoutine.TRIGGER](context, payload) {
    context.commit(xeroIsXeroLoginRoutine.TRIGGER, payload)
  }
}
